import React, { useState } from 'react'
import { Flexbox, Form } from '@/components'
import useDeadKeys from '@/hooks/useDeadKeys'
import { PasswordButton } from '@/views/auth/Login/styles'
import PropTypes from 'prop-types'

function NewPassword({
  values,
  errors,
  touched,
  setFieldValue,
}) {
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const deadKeys = useDeadKeys()

  const toggleShowPassword = () => setShowPassword((isVisible) => !isVisible)
  const toggleShowConfirmPassword = () => setShowConfirmPassword((isVisible) => !isVisible)

  return (
    <div className="p-2">
      <div className="text-center">
        <div className="mb-2">Agora escolha uma nova senha segura</div>
        <Flexbox.Columns className="flex-centered">
          <Flexbox.Column className="col-4 pt-2">
            <Form.Group className="mt-2">
              <div style={{ position: 'relative' }}>
                <Form.Input
                  type={showPassword ? 'text' : 'password'}
                  onKeyDown={deadKeys.onKeyDown}
                  onCompositionStart={deadKeys.onCompositionStart}
                  placeholder="Nova senha"
                  name="password"
                  value={values.password || ''}
                  onChange={(e) => setFieldValue('password', e.target.value)}
                  inputMode="text"
                  lang="pt-BR"
                  autoComplete="new-password"
                  autoCapitalize="none"
                  autoCorrect="off"
                  spellCheck={false}
                  autoFocus
                />
                <PasswordButton
                  type="button"
                  title={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
                  onClick={toggleShowPassword}
                >
                  {showPassword ? (
                    <i className="fas fa-eye-slash text-gray" />
                  ) : (
                    <i className="fas fa-eye text-gray" />
                  )}
                </PasswordButton>
              </div>
              {errors.password && touched.password && (
                <Form.Hint className="text-error mt-1">
                  {errors.password}
                </Form.Hint>
              )}
            </Form.Group>

            <Form.Group className="mt-2">
              <div style={{ position: 'relative' }}>
                <Form.Input
                  type={showConfirmPassword ? 'text' : 'password'}
                  onKeyDown={deadKeys.onKeyDown}
                  onCompositionStart={deadKeys.onCompositionStart}
                  placeholder="Confirmar nova senha"
                  name="password_confirmation"
                  value={values.password_confirmation || ''}
                  onChange={(e) => setFieldValue('password_confirmation', e.target.value)}
                  inputMode="text"
                  lang="pt-BR"
                  autoComplete="new-password"
                  autoCapitalize="none"
                  autoCorrect="off"
                  spellCheck={false}
                />
                <PasswordButton
                  type="button"
                  title={
                    showConfirmPassword ? 'Ocultar senha' : 'Mostrar senha'
                  }
                  onClick={toggleShowConfirmPassword}
                >
                  {showConfirmPassword ? (
                    <i className="fas fa-eye-slash text-gray" />
                  ) : (
                    <i className="fas fa-eye text-gray" />
                  )}
                </PasswordButton>
              </div>
              {errors?.password_confirmation
                && touched?.password_confirmation && (
                  <Form.Hint className="text-error mt-1">
                    {errors.password_confirmation}
                  </Form.Hint>
              )}
            </Form.Group>
          </Flexbox.Column>
        </Flexbox.Columns>
      </div>
    </div>
  )
}

NewPassword.propTypes = {
  values: PropTypes.objectOf(PropTypes.any).isRequired,
  errors: PropTypes.objectOf(PropTypes.any).isRequired,
  touched: PropTypes.objectOf(PropTypes.any).isRequired,
  setFieldValue: PropTypes.func.isRequired,
}

export default NewPassword
